const API_BASE = 'https://xceededge.com';

export default API_BASE;